module.exports = __webpack_public_path__ + "media/components/buttons/static/surf-forecast__logo--white-cfffa938ccec7a30cb3683a2208094f0.svg";